import {
  getObject,
  getOptionalObject,
  getBoolean,
  getOptionalBoolean,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { OpenEndedQuestionV1, OpenEndedQuestionV1DTO } from "./openEndedQuestionV1";
import { SingleChoiceQuestionV1, SingleChoiceQuestionV1DTO } from "./singleChoiceQuestionV1";
import { MultiChoiceQuestionV1, MultiChoiceQuestionV1DTO } from "./multiChoiceQuestionV1";
import { GridQuestionV1, GridQuestionV1DTO } from "./gridQuestionV1";
import { RankingQuestionV1, RankingQuestionV1DTO, RankingQuestionV1Enums } from "./rankingQuestionV1";


export namespace ChildQuestionElementV1Enums {
  export namespace ChildQuestion {
    export interface OpenEndedDTO {
      case: string;
      openEndedQuestionAttributes: OpenEndedQuestionV1DTO;
    }
    
    export class OpenEnded {
      readonly isChildQuestionOpenEnded: boolean = true;
    
      readonly openEndedQuestionAttributes: OpenEndedQuestionV1;
    
    
      constructor(
      openEndedQuestionAttributes: OpenEndedQuestionV1
      ) {
        this.openEndedQuestionAttributes = openEndedQuestionAttributes;
      }
    
      static fromDTO(dto: OpenEndedDTO): OpenEnded {
        const openEndedQuestionAttributes = OpenEndedQuestionV1.fromDTO(getObject(dto, "openEndedQuestionAttributes", InvalidChildQuestionElementV1ChildQuestionOpenEndedOpenEndedQuestionAttributesError));
        return new OpenEnded(
          openEndedQuestionAttributes
        );
      }
    
      toDTO(): OpenEndedDTO {
        const dto: OpenEndedDTO = {
          case: "OPEN_ENDED",
            openEndedQuestionAttributes: this.openEndedQuestionAttributes.toDTO()
        };
        return dto;
      }
      }
    
    OpenEnded.prototype.toString = function toString(): string {
      return `ChildQuestion.OPEN_ENDED(openEndedQuestionAttributes='${this.openEndedQuestionAttributes}')`;
    };
    
    export interface SingleChoiceDTO {
      case: string;
      singleChoiceQuestionAttributes: SingleChoiceQuestionV1DTO;
    }
    
    export class SingleChoice {
      readonly isChildQuestionSingleChoice: boolean = true;
    
      readonly singleChoiceQuestionAttributes: SingleChoiceQuestionV1;
    
    
      constructor(
      singleChoiceQuestionAttributes: SingleChoiceQuestionV1
      ) {
        this.singleChoiceQuestionAttributes = singleChoiceQuestionAttributes;
      }
    
      static fromDTO(dto: SingleChoiceDTO): SingleChoice {
        const singleChoiceQuestionAttributes = SingleChoiceQuestionV1.fromDTO(getObject(dto, "singleChoiceQuestionAttributes", InvalidChildQuestionElementV1ChildQuestionSingleChoiceSingleChoiceQuestionAttributesError));
        return new SingleChoice(
          singleChoiceQuestionAttributes
        );
      }
    
      toDTO(): SingleChoiceDTO {
        const dto: SingleChoiceDTO = {
          case: "SINGLE_CHOICE",
            singleChoiceQuestionAttributes: this.singleChoiceQuestionAttributes.toDTO()
        };
        return dto;
      }
      }
    
    SingleChoice.prototype.toString = function toString(): string {
      return `ChildQuestion.SINGLE_CHOICE(singleChoiceQuestionAttributes='${this.singleChoiceQuestionAttributes}')`;
    };
    
    export interface MultiChoiceDTO {
      case: string;
      multiChoiceQuestionAttributes: MultiChoiceQuestionV1DTO;
    }
    
    export class MultiChoice {
      readonly isChildQuestionMultiChoice: boolean = true;
    
      readonly multiChoiceQuestionAttributes: MultiChoiceQuestionV1;
    
    
      constructor(
      multiChoiceQuestionAttributes: MultiChoiceQuestionV1
      ) {
        this.multiChoiceQuestionAttributes = multiChoiceQuestionAttributes;
      }
    
      static fromDTO(dto: MultiChoiceDTO): MultiChoice {
        const multiChoiceQuestionAttributes = MultiChoiceQuestionV1.fromDTO(getObject(dto, "multiChoiceQuestionAttributes", InvalidChildQuestionElementV1ChildQuestionMultiChoiceMultiChoiceQuestionAttributesError));
        return new MultiChoice(
          multiChoiceQuestionAttributes
        );
      }
    
      toDTO(): MultiChoiceDTO {
        const dto: MultiChoiceDTO = {
          case: "MULTI_CHOICE",
            multiChoiceQuestionAttributes: this.multiChoiceQuestionAttributes.toDTO()
        };
        return dto;
      }
      }
    
    MultiChoice.prototype.toString = function toString(): string {
      return `ChildQuestion.MULTI_CHOICE(multiChoiceQuestionAttributes='${this.multiChoiceQuestionAttributes}')`;
    };
    
    export interface GridDTO {
      case: string;
      gridQuestionAttributes: GridQuestionV1DTO;
    }
    
    export class Grid {
      readonly isChildQuestionGrid: boolean = true;
    
      readonly gridQuestionAttributes: GridQuestionV1;
    
    
      constructor(
      gridQuestionAttributes: GridQuestionV1
      ) {
        this.gridQuestionAttributes = gridQuestionAttributes;
      }
    
      static fromDTO(dto: GridDTO): Grid {
        const gridQuestionAttributes = GridQuestionV1.fromDTO(getObject(dto, "gridQuestionAttributes", InvalidChildQuestionElementV1ChildQuestionGridGridQuestionAttributesError));
        return new Grid(
          gridQuestionAttributes
        );
      }
    
      toDTO(): GridDTO {
        const dto: GridDTO = {
          case: "GRID",
            gridQuestionAttributes: this.gridQuestionAttributes.toDTO()
        };
        return dto;
      }
      }
    
    Grid.prototype.toString = function toString(): string {
      return `ChildQuestion.GRID(gridQuestionAttributes='${this.gridQuestionAttributes}')`;
    };
    
    export interface RankingDTO {
      case: string;
      rankingQuestionAttributes: RankingQuestionV1DTO;
    }
    
    export class Ranking {
      readonly isChildQuestionRanking: boolean = true;
    
      readonly rankingQuestionAttributes: RankingQuestionV1;
    
    
      constructor(
      rankingQuestionAttributes: RankingQuestionV1
      ) {
        this.rankingQuestionAttributes = rankingQuestionAttributes;
      }
    
      static fromDTO(dto: RankingDTO): Ranking {
        const rankingQuestionAttributes = RankingQuestionV1.fromDTO(getObject(dto, "rankingQuestionAttributes", InvalidChildQuestionElementV1ChildQuestionRankingRankingQuestionAttributesError));
        return new Ranking(
          rankingQuestionAttributes
        );
      }
    
      toDTO(): RankingDTO {
        const dto: RankingDTO = {
          case: "RANKING",
            rankingQuestionAttributes: this.rankingQuestionAttributes.toDTO()
        };
        return dto;
      }
      }
    
    Ranking.prototype.toString = function toString(): string {
      return `ChildQuestion.RANKING(rankingQuestionAttributes='${this.rankingQuestionAttributes}')`;
    };
    
    export interface MessageDTO {
      case: string;
    }
    
    export class Message {
      readonly isChildQuestionMessage: boolean = true;
    
    
    
    
    
      toDTO(): MessageDTO {
        const dto: MessageDTO = {
          case: "MESSAGE",
        };
        return dto;
      }
      }
    
    Message.prototype.toString = function toString(): string {
      return `ChildQuestion.MESSAGE()`;
    };
    
  
    export type ChildQuestion = OpenEnded | SingleChoice | MultiChoice | Grid | Ranking | Message;
  
    export type ChildQuestionDTO = OpenEndedDTO | SingleChoiceDTO | MultiChoiceDTO | GridDTO | RankingDTO | MessageDTO;
  
    export const fromDTO = (dto: ChildQuestionDTO): ChildQuestion => {
      switch (dto.case) {
        case "OPEN_ENDED":
            return OpenEnded.fromDTO(dto as OpenEndedDTO);
        case "SINGLE_CHOICE":
            return SingleChoice.fromDTO(dto as SingleChoiceDTO);
        case "MULTI_CHOICE":
            return MultiChoice.fromDTO(dto as MultiChoiceDTO);
        case "GRID":
            return Grid.fromDTO(dto as GridDTO);
        case "RANKING":
            return Ranking.fromDTO(dto as RankingDTO);
        case "MESSAGE":
            return new Message();
        default:
          throw new InvalidChildQuestionElementV1ChildQuestionError(
              `Case ${dto.case} is not valid case of ChildQuestion.`
          );
      }
    };
  }
  
}
export interface ChildQuestionElementV1DTO {
  childQuestionCode: CodeDTO;
  question?: SurveyLocalizedTextDTO | null;
  questionDescription?: SurveyLocalizedTextDTO | null;
  isMandatory: boolean;
  isUnanswered?: boolean | null;
  childQuestion: ChildQuestionElementV1Enums.ChildQuestion.ChildQuestionDTO;
}

export class ChildQuestionElementV1 {
  readonly isChildQuestionElementV1ChildQuestionElementV1: boolean = true;

  readonly childQuestionCode: Code;
  readonly question: SurveyLocalizedText | null;
  readonly questionDescription: SurveyLocalizedText | null;
  readonly isMandatory: boolean;
  readonly isUnanswered: boolean | null;
  readonly childQuestion: ChildQuestionElementV1Enums.ChildQuestion.ChildQuestion;


  constructor(
  childQuestionCode: Code, 
  question: SurveyLocalizedText | null = null, 
  questionDescription: SurveyLocalizedText | null = null, 
  isMandatory: boolean, 
  isUnanswered: boolean | null = null, 
  childQuestion: ChildQuestionElementV1Enums.ChildQuestion.ChildQuestion
  ) {
    this.childQuestionCode = childQuestionCode;
    this.question = question;
    this.questionDescription = questionDescription;
    this.isMandatory = isMandatory;
    this.isUnanswered = isUnanswered;
    this.childQuestion = childQuestion;
  }

  static fromDTO(dto: ChildQuestionElementV1DTO): ChildQuestionElementV1 {
    const childQuestionCode = Code.fromDTO(getObject(dto, "childQuestionCode", InvalidChildQuestionElementV1ChildQuestionCodeError));
    let question = getOptionalObject(dto, "question");
    if(question !== undefined && question !== null) {
      question = SurveyLocalizedText.fromDTO(getObject(dto, "question", InvalidChildQuestionElementV1QuestionError));
    }
    let questionDescription = getOptionalObject(dto, "questionDescription");
    if(questionDescription !== undefined && questionDescription !== null) {
      questionDescription = SurveyLocalizedText.fromDTO(getObject(dto, "questionDescription", InvalidChildQuestionElementV1QuestionDescriptionError));
    }
    const isMandatory = getBoolean(dto, "isMandatory", InvalidChildQuestionElementV1IsMandatoryError);
    const isUnanswered = getOptionalBoolean(dto, "isUnanswered", InvalidChildQuestionElementV1IsUnansweredError);
    const childQuestion = ChildQuestionElementV1Enums.ChildQuestion.fromDTO(getObject(dto, "childQuestion", InvalidChildQuestionElementV1ChildQuestionError));
    return new ChildQuestionElementV1(
      childQuestionCode,
      question,
      questionDescription,
      isMandatory,
      isUnanswered,
      childQuestion
    );
  }

  toDTO(): ChildQuestionElementV1DTO {
    const dto: ChildQuestionElementV1DTO = {
        childQuestionCode: this.childQuestionCode.toDTO(),
        isMandatory: this.isMandatory,
        childQuestion: this.childQuestion.toDTO()
    };
    if (this.question !== undefined && this.question !== null){
      dto.question = this.question.toDTO();
    }
    if (this.questionDescription !== undefined && this.questionDescription !== null){
      dto.questionDescription = this.questionDescription.toDTO();
    }
    if (this.isUnanswered !== undefined && this.isUnanswered !== null){
      dto.isUnanswered = this.isUnanswered;
    }
    return dto;
  }
  }

ChildQuestionElementV1.prototype.toString = function toString(): string {
  return `ChildQuestionElementV1(childQuestionCode='${this.childQuestionCode}',question='${this.question}',questionDescription='${this.questionDescription}',isMandatory='${this.isMandatory}',isUnanswered='${this.isUnanswered}',childQuestion='${this.childQuestion}')`;
};

export class InvalidChildQuestionElementV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1Error";
  }
}
export class InvalidChildQuestionElementV1ChildQuestionCodeError extends InvalidChildQuestionElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionCodeError";
  }
}

export class InvalidChildQuestionElementV1QuestionError extends InvalidChildQuestionElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1QuestionError";
  }
}

export class InvalidChildQuestionElementV1QuestionDescriptionError extends InvalidChildQuestionElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1QuestionDescriptionError";
  }
}

export class InvalidChildQuestionElementV1IsMandatoryError extends InvalidChildQuestionElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1IsMandatoryError";
  }
}

export class InvalidChildQuestionElementV1IsUnansweredError extends InvalidChildQuestionElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1IsUnansweredError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionError extends InvalidChildQuestionElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionOpenEndedError extends InvalidChildQuestionElementV1ChildQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionOpenEndedError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionOpenEndedOpenEndedQuestionAttributesError extends InvalidChildQuestionElementV1ChildQuestionOpenEndedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionOpenEndedOpenEndedQuestionAttributesError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionSingleChoiceError extends InvalidChildQuestionElementV1ChildQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionSingleChoiceError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionSingleChoiceSingleChoiceQuestionAttributesError extends InvalidChildQuestionElementV1ChildQuestionSingleChoiceError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionSingleChoiceSingleChoiceQuestionAttributesError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionMultiChoiceError extends InvalidChildQuestionElementV1ChildQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionMultiChoiceError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionMultiChoiceMultiChoiceQuestionAttributesError extends InvalidChildQuestionElementV1ChildQuestionMultiChoiceError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionMultiChoiceMultiChoiceQuestionAttributesError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionGridError extends InvalidChildQuestionElementV1ChildQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionGridError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionGridGridQuestionAttributesError extends InvalidChildQuestionElementV1ChildQuestionGridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionGridGridQuestionAttributesError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionRankingError extends InvalidChildQuestionElementV1ChildQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionRankingError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionRankingRankingQuestionAttributesError extends InvalidChildQuestionElementV1ChildQuestionRankingError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionRankingRankingQuestionAttributesError";
  }
}

export class InvalidChildQuestionElementV1ChildQuestionMessageError extends InvalidChildQuestionElementV1ChildQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChildQuestionElementV1ChildQuestionMessageError";
  }
}
